module.exports = __webpack_public_path__ + "img/preppy.ae5af8f7.webp";